(() => {
  const money = (cents) =>
    (cents / 100).toLocaleString("pt-BR", { style: "currency", currency: "BRL" });

  const qs = (sel, root = document) => root.querySelector(sel);
  const qsa = (sel, root = document) => [...root.querySelectorAll(sel)];

  document.addEventListener("click", (event) => {
    const prev = event.target.closest("[data-scroll-prev]");
    const next = event.target.closest("[data-scroll-next]");
    if (prev || next) {
      const scroller = (prev || next).parentElement.querySelector("[data-scroll]");
      if (scroller) scroller.scrollBy({ left: (next ? 1 : -1) * 240, behavior: "smooth" });
    }

    if (event.target.closest("[data-search-toggle]")) {
      qs("[data-search]")?.classList.toggle("is-open");
      qs("[data-search] input")?.focus();
    }

    const catalogTrigger = event.target.closest("[data-catalog-open]");
    if (catalogTrigger) {
      event.preventDefault();
      const header = qs(".header");
      const pick = catalogTrigger.dataset.catalogPick;
      const openNow = header?.classList.contains("is-catalog");
      const same = pick && header?.dataset.catalogCurrent === pick;
      const open = pick ? !(openNow && same) : !openNow;
      header?.classList.toggle("is-catalog", open);
      if (pick && open) {
        header.dataset.catalogCurrent = pick;
        activateCatalog(pick);
      } else if (!open) {
        delete header.dataset.catalogCurrent;
      }
      qsa("[data-catalog-open]").forEach((button) => {
        const selected = open && pick && button.dataset.catalogPick === pick;
        button.classList.toggle("is-active", selected);
        button.setAttribute("aria-expanded", String(open && (!pick || selected || !button.dataset.catalogPick)));
      });
      document.body.classList.toggle("catalog-open", open && window.innerWidth < 990);
    }
    if (event.target.closest("[data-catalog-close]")) {
      qs(".header")?.classList.remove("is-catalog");
      document.body.classList.remove("catalog-open");
    }
    const tab = event.target.closest("[data-catalog-tab]");
    if (tab) activateCatalog(tab.dataset.catalogTab);

    const wish = event.target.closest("[data-wish]");
    if (wish) {
      event.preventDefault();
      const id = wish.dataset.wish;
      const key = "excitame-wish";
      const list = JSON.parse(localStorage.getItem(key) || "[]");
      const has = list.includes(id);
      const nextList = has ? list.filter((item) => item !== id) : [...list, id];
      localStorage.setItem(key, JSON.stringify(nextList));
      wish.classList.toggle("is-on", !has);
      wish.setAttribute("aria-pressed", String(!has));
    }

    if (event.target.closest("[data-cart-open]")) {
      event.preventDefault();
      openCart();
    }
    if (event.target.closest("[data-cart-close]")) closeCart();
  });

  qsa("[data-wish]").forEach((button) => {
    const list = JSON.parse(localStorage.getItem("excitame-wish") || "[]");
    if (list.includes(button.dataset.wish)) {
      button.classList.add("is-on");
      button.setAttribute("aria-pressed", "true");
    }
  });

  const drawer = qs("[data-drawer]");
  const openCart = async () => {
    await refreshCart();
    drawer.hidden = false;
    document.body.style.overflow = "hidden";
  };
  const closeCart = () => {
    drawer.hidden = true;
    document.body.style.overflow = "";
  };

  const setCount = (count) => {
    qsa("[data-cart-count]").forEach((node) => {
      node.textContent = count;
    });
  };

  const renderItems = (cart) => {
    const box = qs("[data-cart-items]");
    const total = qs("[data-cart-total]");
    if (!box) return;
    if (!cart.items.length) {
      box.innerHTML = '<p class="drawer__empty">O seu carrinho está vazio</p>';
    } else {
      box.innerHTML = cart.items
        .map(
          (item) => `
        <article class="drawer__item">
          <img src="${item.image || ""}" alt="">
          <div>
            <a class="drawer__name" href="${item.url}">${item.product_title.toLowerCase()}</a>
            <div class="mini-qty">
              <button type="button" data-qty="${item.key}" data-delta="-1" aria-label="Diminuir">−</button>
              <span>${item.quantity}</span>
              <button type="button" data-qty="${item.key}" data-delta="1" aria-label="Aumentar">+</button>
            </div>
          </div>
          <strong>${money(item.final_line_price)}</strong>
        </article>`
        )
        .join("");
    }
    if (total) total.textContent = money(cart.total_price);
    const discounts = qs("[data-cart-discounts]");
    if (discounts) {
      discounts.innerHTML = (cart.cart_level_discount_applications || [])
        .map((discount) => `<p class="cart-summary__row"><span>${discount.title}</span> <span>-${money(discount.total_allocated_amount)}</span></p>`)
        .join("");
    }
    updatePayChoice(cart);
    setCount(cart.item_count);
  };

  // Totais estimados de cada forma de pagamento e opção marcada, a partir do carrinho atual.
  const updatePayChoice = (cart) => {
    const chosen = cart.attributes?.pagamento || "";
    qsa("[data-pay-choice]").forEach((form) => {
      const percents = { pix: Number(form.dataset.pix || 0), cartao: Number(form.dataset.card || 0) };
      Object.entries(percents).forEach(([key, percent]) => {
        const node = qs(`[data-pay-total="${key}"]`, form);
        if (node) node.textContent = money(Math.round((cart.items_subtotal_price * (100 - percent)) / 100));
      });
      qsa('input[name="pagamento"]', form).forEach((input) => {
        input.checked = input.value === chosen;
      });
    });
  };

  // A escolha vira o atributo "pagamento" do carrinho, lido pelo app no checkout.
  let paySaving = null;
  document.addEventListener("change", async (event) => {
    const input = event.target.closest('[data-pay-choice] input[name="pagamento"]');
    if (!input) return;
    qsa("[data-pay-error]").forEach((node) => {
      node.hidden = true;
    });
    const radios = qsa('[data-pay-choice] input[name="pagamento"]');
    radios.forEach((radio) => {
      radio.disabled = true;
    });
    paySaving = fetch("/cart/update.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ attributes: { pagamento: input.value } }),
    });
    try {
      await paySaving;
      if (qs(".cart-page")) {
        window.location.reload();
        return;
      }
      await refreshCart();
    } finally {
      paySaving = null;
      radios.forEach((radio) => {
        radio.disabled = false;
      });
    }
  });

  // Sem forma de pagamento escolhida, o botão de finalizar não segue para o checkout.
  document.addEventListener("click", async (event) => {
    const link = event.target.closest("[data-checkout]");
    if (!link) return;
    const scope = link.closest("[data-drawer], .cart-summary") || document;
    const form = qs("[data-pay-choice]", scope);
    if (!form) return;
    event.preventDefault();
    if (!qs('input[name="pagamento"]:checked', form)) {
      const error = qs("[data-pay-error]", form);
      if (error) error.hidden = false;
      qs('input[name="pagamento"]', form)?.focus();
      return;
    }
    if (paySaving) await paySaving.catch(() => {});
    window.location.href = link.href;
  });

  const refreshCart = async () => {
    const cart = await fetch("/cart.js").then((response) => response.json());
    renderItems(cart);
    return cart;
  };

  const addToCart = async (payload) => {
    const response = await fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    });
    if (!response.ok) {
      const error = await response.json().catch(() => ({}));
      throw new Error(error.description || "Não foi possível adicionar");
    }
    await openCart();
  };

  const addVariant = (id, quantity = 1) => addToCart({ id, quantity });

  document.addEventListener("click", async (event) => {
    const add = event.target.closest("[data-add]");
    if (add) {
      event.preventDefault();
      add.disabled = true;
      try {
        await addVariant(add.dataset.add, 1);
      } catch (error) {
        window.alert(error.message);
      } finally {
        add.disabled = false;
      }
    }

    const qty = event.target.closest("[data-qty]");
    if (qty) {
      const cart = await fetch("/cart.js").then((response) => response.json());
      const line = cart.items.find((item) => item.key === qty.dataset.qty);
      const quantity = Math.max(0, (line?.quantity || 1) + Number(qty.dataset.delta));
      await fetch("/cart/change.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id: qty.dataset.qty, quantity }),
      });
      await refreshCart();
    }
  });

  const productLine = (productForm) => {
    if (!productForm) return null;
    const grades = qsa("[data-grade-qty]", productForm);
    if (grades.length) {
      const chosen = grades.find((input) => !input.disabled && Number(input.value) > 0)
        || grades.find((input) => !input.disabled)
        || grades[0];
      return { id: chosen.dataset.variant, quantity: Math.max(1, Number(chosen.value || 1)) };
    }
    const data = new FormData(productForm);
    return { id: data.get("id"), quantity: Number(data.get("quantity") || 1) };
  };

  qs("#product-form")?.addEventListener("submit", async (event) => {
    event.preventDefault();
    const form = event.currentTarget;
    const button = qs("[type=submit]", form);
    const wasDisabled = button?.disabled;
    if (button) button.disabled = true;
    try {
      const grades = qsa("[data-grade-qty]", form);
      if (grades.length) {
        const items = grades
          .map((input) => ({ id: Number(input.dataset.variant), quantity: Number(input.value || 0) }))
          .filter((item) => item.quantity > 0);
        if (!items.length) throw new Error("Informe a quantidade de ao menos uma opção.");
        await addToCart({ items });
        return;
      }
      const line = productLine(form);
      await addVariant(line.id, line.quantity);
    } catch (error) {
      window.alert(error.message);
    } finally {
      if (button && !wasDisabled) button.disabled = false;
    }
  });

  qsa("[data-qty-input]").forEach((input) => {
    input.addEventListener("focus", () => input.select());
    input.addEventListener("input", () => {
      if (!input.hasAttribute("data-grade-qty")) return;
      input.value = input.value.replace(/\D/g, "").replace(/^0+(?=\d)/, "");
    });
    input.parentElement?.addEventListener("click", (event) => {
      const button = event.target.closest("[data-qty-step]");
      if (!button || input.disabled || button.disabled) return;
      const min = Number(input.dataset.min ?? 1);
      const next = Math.max(min, Number(input.value || min) + Number(button.dataset.qtyStep));
      input.value = next;
    });
  });

  qsa("[data-gallery]").forEach((gallery) => {
    const stage = qs(".product__stage img", gallery);
    gallery.addEventListener("click", (event) => {
      const button = event.target.closest("[data-full]");
      if (!button || !stage) return;
      stage.src = button.dataset.full;
      stage.alt = button.dataset.alt || "";
      qsa("[data-full]", gallery).forEach((item) => item.classList.remove("is-active"));
      button.classList.add("is-active");
    });
  });

  const esc = (value) =>
    String(value ?? "").replace(/[&<>"']/g, (char) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[char]));

  const moneyRate = (price) => {
    const value = Number(price);
    if (!Number.isFinite(value) || value <= 0) return "Grátis";
    return value.toLocaleString("pt-BR", { style: "currency", currency: "BRL" });
  };

  const prazo = (rate) => {
    const days = rate.delivery_days;
    if (Array.isArray(days) && days.length) {
      const [min, max] = days;
      if (max && Number(max) !== Number(min)) return `${min} a ${max} dias úteis`;
      if (min) return Number(min) === 1 ? "1 dia útil" : `${min} dias úteis`;
    }
    if (typeof days === "number" && days > 0) return days === 1 ? "1 dia útil" : `${days} dias úteis`;
    const range = rate.delivery_range;
    if (Array.isArray(range) && range[0]) {
      const fmt = (iso) => {
        const date = new Date(`${iso}T12:00:00`);
        return Number.isNaN(date.getTime()) ? "" : date.toLocaleDateString("pt-BR", { day: "2-digit", month: "short" });
      };
      const start = fmt(range[0]);
      const end = range[1] ? fmt(range[1]) : "";
      if (start && end && start !== end) return `Chega entre ${start} e ${end}`;
      if (start) return `Chega em ${start}`;
    }
    return rate.description || "";
  };

  const shipMessage = (output, message, kind = "error") => {
    output.innerHTML = `<p class="ship__note ship__note--${kind}">${esc(message)}</p>`;
  };

  const quote = async (zip, output, item = null) => {
    const digits = String(zip || "").replace(/\D/g, "");
    if (digits.length !== 8) {
      shipMessage(output, "Informe um CEP com 8 números.");
      return;
    }
    const button = output.closest("form")?.querySelector("button");
    if (button) button.disabled = true;
    output.setAttribute("aria-busy", "true");
    output.innerHTML = `<div class="ship__loading" role="status"><span class="ship__spinner" aria-hidden="true"></span><span><strong>Estamos calculando o frete.</strong> Isso pode levar alguns segundos.</span></div>`;
    let province = "";
    let stopped = false;
    // A Shopify só cota o carrinho: na página do produto, o item entra temporariamente.
    let temp = null;
    let data;
    try {
      try {
        const via = await fetch(`https://viacep.com.br/ws/${digits}/json/`).then((response) => response.json());
        if (via.erro) {
          shipMessage(output, "CEP não encontrado.");
          stopped = true;
          return;
        }
        province = via.uf || "";
      } catch (error) {
        province = "";
      }
      const params = new URLSearchParams();
      params.set("shipping_address[zip]", digits);
      params.set("shipping_address[country]", "Brazil");
      if (province) params.set("shipping_address[province]", province);

      if (item) {
        const cart = await fetch("/cart.js").then((response) => response.json());
        if (!cart.items.some((line) => String(line.variant_id) === String(item.id))) {
          const added = await fetch("/cart/add.js", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ id: item.id, quantity: item.quantity }),
          });
          const line = await added.json().catch(() => ({}));
          if (!added.ok) {
            shipMessage(output, line.description || "Não foi possível calcular o frete deste produto.");
            stopped = true;
            return;
          }
          temp = { key: line.key, quantity: item.quantity };
        }
      }
      data = await fetchRates(params);
    } catch (error) {
      data = { error: "Não foi possível calcular o frete. Tente novamente." };
    } finally {
      if (temp) await removeTemp(temp).catch(() => {});
      if (button) button.disabled = false;
      output.removeAttribute("aria-busy");
    }
    if (stopped) return;

    if (data.error || !data.shipping_rates) {
      shipMessage(output, data.zip?.[0] || data.province?.[0] || data.error || "Adicione um produto ao carrinho para calcular o frete.");
      return;
    }
    const rates = [...data.shipping_rates].sort((a, b) => Number(a.price) - Number(b.price));
    if (!rates.length) {
      shipMessage(output, "Nenhuma opção de frete para este CEP.");
      return;
    }
    const cep = `${digits.slice(0, 5)}-${digits.slice(5)}`;
    output.innerHTML = `<p class="ship__for">Opções para ${esc(cep)}</p><ul class="ship__rates">${rates
      .map((rate, index) => {
        const when = prazo(rate);
        const price = moneyRate(rate.price);
        const free = price === "Grátis";
        return `<li><div><strong>${esc(rate.presentment_name || rate.name)}</strong>${when ? `<span>${esc(when)}</span>` : ""}${index === 0 && rates.length > 1 ? `<em>menor preço</em>` : ""}</div><b class="${free ? "is-free" : ""}">${esc(price)}</b></li>`;
      })
      .join("")}</ul>`;
  };

  // Fluxo assíncrono recomendado para frete calculado por app (ex.: Frenet).
  const fetchRates = async (params) => {
    const prepared = await fetch(`/cart/prepare_shipping_rates.json?${params.toString()}`, { method: "POST" });
    if (!prepared.ok) return prepared.json().catch(() => ({}));
    for (let attempt = 0; attempt < 24; attempt += 1) {
      const response = await fetch("/cart/async_shipping_rates.json");
      const body = await response.json().catch(() => null);
      if (!response.ok) return body || {};
      if (body) return body;
      await new Promise((resolve) => setTimeout(resolve, 500));
    }
    return { error: "O cálculo do frete demorou demais. Tente novamente." };
  };

  // Desconta só a quantidade temporária, preservando o que o cliente adicionar no meio do cálculo.
  const removeTemp = async ({ key, quantity }) => {
    const cart = await fetch("/cart.js").then((response) => response.json());
    const line = cart.items.find((entry) => entry.key === key);
    if (!line) return;
    await fetch("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id: key, quantity: Math.max(0, line.quantity - quantity) }),
    });
  };

  qsa("[name=zip]").forEach((input) => {
    input.addEventListener("input", () => {
      const digits = input.value.replace(/\D/g, "").slice(0, 8);
      const masked = digits.length > 5 ? `${digits.slice(0, 5)}-${digits.slice(5)}` : digits;
      if (input.value !== masked) input.value = masked;
    });
  });

  qsa("[data-ship]").forEach((form) => {
    form.addEventListener("submit", (event) => {
      event.preventDefault();
      const productForm = form.closest("[data-drawer]") ? null : qs("#product-form");
      const item = productLine(productForm);
      quote(new FormData(form).get("zip"), qs("[data-ship-result]", form), item);
    });
  });

  qs("[data-coupon]")?.addEventListener("submit", (event) => {
    event.preventDefault();
    const code = new FormData(event.currentTarget).get("discount");
    if (!code) return;
    window.location.href = `/discount/${encodeURIComponent(code)}?redirect=${encodeURIComponent(window.location.pathname)}`;
  });

  const activateCatalog = (id) => {
    qsa("[data-catalog-tab]").forEach((tab) => tab.classList.toggle("is-active", tab.dataset.catalogTab === id));
    qsa("[data-catalog-panel]").forEach((panel) => panel.classList.toggle("is-active", panel.dataset.catalogPanel === id));
    qsa("[data-catalog-details]").forEach((item) => {
      item.open = item.dataset.catalogDetails === id;
    });
  };

  qsa("[data-catalog-tab]").forEach((tab) => {
    tab.addEventListener("mouseenter", () => {
      if (window.innerWidth >= 990) activateCatalog(tab.dataset.catalogTab);
    });
  });

  document.addEventListener("click", (event) => {
    const header = qs(".header");
    if (!header?.classList.contains("is-catalog")) return;
    if (event.target.closest(".header")) return;
    header.classList.remove("is-catalog");
    delete header.dataset.catalogCurrent;
    qsa("[data-catalog-open]").forEach((button) => {
      button.classList.remove("is-active");
      button.setAttribute("aria-expanded", "false");
    });
    document.body.classList.remove("catalog-open");
  });

  document.addEventListener("keydown", (event) => {
    if (event.key === "Escape") {
      const header = qs(".header");
      header?.classList.remove("is-catalog");
      if (header) delete header.dataset.catalogCurrent;
      qsa("[data-catalog-open]").forEach((button) => {
        button.classList.remove("is-active");
        button.setAttribute("aria-expanded", "false");
      });
      document.body.classList.remove("catalog-open");
    }
  });

  let predictiveTimer;
  document.addEventListener("input", (event) => {
    const input = event.target.closest("[data-predictive-input]");
    if (!input) return;
    const root = input.closest("[data-predictive]");
    const box = root?.querySelector("[data-predictive-results]");
    if (!root || !box) return;
    window.clearTimeout(predictiveTimer);
    const term = input.value.trim();
    if (term.length < 2) {
      box.hidden = true;
      return;
    }
    predictiveTimer = window.setTimeout(async () => {
      const url = new URL(root.dataset.predictive, window.location.origin);
      url.searchParams.set("q", term);
      url.searchParams.set("resources[type]", "product");
      url.searchParams.set("resources[limit]", "6");
      url.searchParams.set("resources[options][unavailable_products]", "show");
      url.searchParams.set("resources[options][fields]", "title,product_type,variants.title,vendor");
      const data = await fetch(url).then((response) => response.json());
      const products = data?.resources?.results?.products || [];
      box.innerHTML = products.length
        ? products.map((product) => `<a href="${product.url}">${product.title}</a>`).join("")
        : `<p class="empty">Nenhum produto</p>`;
      box.hidden = false;
    }, 200);
  });

  qs("[data-track]")?.addEventListener("submit", (event) => {
    event.preventDefault();
    const code = new FormData(event.currentTarget).get("code");
    if (!code) return;
    window.open(`https://rastreamento.correios.com.br/app/index.php?objetos=${encodeURIComponent(code)}`, "_blank", "noopener");
  });
})();
